import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import { RowNode } from "ag-grid-community";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_RCV_REG_010_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRefL = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);

    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);

    const [selectedTabPage, setTapPage] = useState<string>("1");
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow, // Expose the function as part of an object
    }));

    const getSelectedRow = () => {
      if (selectedTabPage === "1") {
        return [
          gridApiRefH.current.getSelectedRows() || [],
          gridApiRefL.current.getSelectedRows() || [],
        ];
      } else {
        return [[], []]; // Default case for unknown tab pages
      }
    };

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_MTL_RCV_REG_010_POP_001", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정

          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "sn_mtl_rcv_reg_010_pop_01_01",
            params: searchRef.current.getFormdata(),
          };

           const modifiedRowsH = gridApiRefH.current.getChange();
              if (
                modifiedRowsH.modifiedRowcount > 0
              ) {
                const confirm = await showDialog(
                  "confirm",
                  "수정된 내용이 있습니다. 저장하시겠습니까?"
                );
              }

          setDataSource1([]);
          setDataSource2([]);
          const data: any = await fnGetDataSet(param);
          console.log(selectedTabPage);
          console.log(data);
          if (selectedTabPage === "1") {
            setDataSource1(data[0]);
            setDataSource2(data[1] || []);

            if (data[0] && data[0].length > 0) {
              await new Promise((resolve) => setTimeout(resolve, 50));

              gridApiRefH?.current.selectAndFocusRow(0);
              const rowNode = gridApiRefH.current?.api.getDisplayedRowAtIndex(0);

              if(rowNode){
                rowNode.setSelected(false);
              }
            }
          }     
        } catch (error: any) {
          //showDialog("error", error.message);
        }
      };
      fetchdatasource();    
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      if (selectedRow) {
        const cd_cust = selectedRow.cd_cust;
        const cd_exch = selectedRow.cd_exch;
        const fg_trns = selectedRow.fg_trns;
        gridApiRefL.current.applyFilters({
          cd_cust: cd_cust,
          cd_exch: cd_exch,
          fg_trns: fg_trns,
        });
        gridApiRefL.current.selectAndFocusRow(0);
      } else {
        return;
      }
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);
    };

    const isChildSelect = useRef(false);

    const onSelectionChangedH = (selectedRows: any) => {
          if (!selectedRows) return;
    
          let cdCust = selectedRows[0]?.cd_cust; // First selected row's cd_cust
          const focusedCell = gridApiRefH.current.api.getFocusedCell();
    
          if (focusedCell) {
            const rowNode = gridApiRefH.current.api.getDisplayedRowAtIndex(
              focusedCell.rowIndex
            );
    
            if (
              rowNode?.data &&
              rowNode.isSelected() &&
              cdCust !== rowNode.data.cd_cust
            ) {
              //showDialog("error", "서로 다른 거래처를 선택하셨습니다.");
              rowNode.setSelected(false);
              //gridApiRefL.current.api.deselectAllFiltered();
              return;
            }
            const gvLDisplaysNodes = gridApiRefL.current.api.getRenderedNodes();
            if (!rowNode.isSelected()) {
              gvLDisplaysNodes.forEach((node: any) => {
                if (node.isSelected()) node.setSelected(false);
              });
            } else {
              if (isChildSelect.current) return;
              gvLDisplaysNodes.forEach((node: any) => {
                if (!node.isSelected()) node.setSelected(true);
              });
            }
          }
        };

        const onSelectionChangedL = (selectedRows: any[]) => {
              if (!selectedRows || selectedRows.length === 0) return;
        
              const selectedNodes: RowNode[] =
                gridApiRefL.current.api.getSelectedNodes();
              const parentfocusedCell = gridApiRefH.current.api.getFocusedCell();
        
              if (!parentfocusedCell) return;
        
              const parentRowNode = gridApiRefH.current.api.getDisplayedRowAtIndex(
                parentfocusedCell.rowIndex
              );
              if (!parentRowNode) return;
        
              const parentCdCust = parentRowNode.data?.cd_cust;
              const selectedCdCust = selectedRows[0]?.cd_cust; // Get the first selected child row's cd_cust
        
              if (parentCdCust !== selectedCdCust) {
                //showDialog("error", "서로 다른 거래처를 선택하셨습니다.");
                selectedNodes.forEach((node: RowNode) => node.setSelected(false)); // Explicitly define node type
                return;
              }
        
              // If cd_cust matches, proceed with selection
              isChildSelect.current = true;
              parentRowNode.setSelected(selectedNodes.length > 0);
              setTimeout(() => {
                isChildSelect.current = false;
              }, 0);
            };
    //#endregion

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div>
          <SnTab
            titles={["반품적용"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div>
                <div style={{ height: "25vh", marginTop: "10px" }}>
                  <SnGrid
                    ref={gridApiRefH}
                    columnConfig={columns1}
                    rowData={dataSource1}
                    rowSelection="single"
                    isEditable={false}
                    enableAddRow={false}
                    ischeckboxSelection={true}
                    onSelectionChanged={onSelectionChangedH}
                    onFocusedRowChanged={onFocusedRowChanged}
                  />
                </div>
                <div style={{ height: "25vh", marginTop: "10px" }}>
                  <SnGrid
                    ref={gridApiRefL}
                    columnConfig={columns2}
                    rowData={dataSource2}
                    rowSelection="multiple"
                    isEditable={false}
                    enableAddRow={false}
                    ischeckboxSelection={true}
                    onSelectionChanged={onSelectionChangedL}
                  />
                </div>
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_MTL_RCV_REG_010_POP_001;
